import defaultAwsconfig from "@/aws-exports";
import devAwsconfig from "@/exports/aws-exports-dev";
import qaAwsconfig from "@/exports/aws-exports-qa";
import prodAwsconfig from "@/exports/aws-exports-prod";

const envAwsConfig = {
  dev: devAwsconfig,
  qa: qaAwsconfig,
  prod: prodAwsconfig
};

function getEnvConfig(env) {
  const config = envAwsConfig[env];

  if (config == null || config == undefined) return envAwsConfig.prod;

  return config;
}

export function getEnvironment() {
  try {
    return process.env.VUE_APP_ENVIRONMENT;
  } catch (e) {}
  return "prod";
}

function configureAmplify(Amplify, runtimeConfig) {
  const environmentConfig = getEnvConfig(getEnvironment());

  const newConfig = { ...defaultAwsconfig, ...environmentConfig };
  Amplify.configure(newConfig);
  if (runtimeConfig != null) Amplify.configure(runtimeConfig);
}

export default { configureAmplify };
